module.exports = __webpack_public_path__ + "static/media/hyderabad to banglore.7db59a5e.jpg";